import { defineComponent } from 'vue';

import { UserRoleType } from '@/services/users/users.types';
import { checkUserAccess } from '@/utils/users/check-user-access';
import { mapState } from 'vuex';

export const userAccessMixin = defineComponent({
  computed: {
    ...mapState('user', ['authenticatedUser']),
    UserRoleType() {
      return UserRoleType;
    }
  },
  methods: {
    hasAccess(role: UserRoleType[]) {
      return checkUserAccess(this.authenticatedUser, role);
    }
  }
});
